export const marks = {
    '0': {
        style: {
            color: 'red'
        },
        label: '9'
    },
    '5': '',
    '10': {
        style: {
            color: 'red'
        },
        label: '7'
    },
    '15': '',
    '20': {
        style: {
            color: 'red'
        },
        label: '5'
    },
    '25': '',
    '30': {
        style: {
            color: 'red'
        },
        label: '3'
    },
    '35': '',
    '40': {
        style: {
            color: 'black'
        },
        label: '1'
    },
    '45': '',
    '50': {
        style: {
            color: 'blue'
        },
        label: '3'
    },
    '55': '',
    '60': {
        style: {
            color: 'blue'
        },
        label: '5'
    },
    '65': '',
    '70': {
        style: {
            color: 'blue'
        },
        label: '7'
    },
    '75': '',
    '80': {
        style: {
            color: 'blue'
        },
        label: '9'
    }
}

export const fullMarks = {
    '0': '1/9',
    '5': '1/8',
    '10': '1/7',
    '15': '1/6',
    '20': '1/5',
    '25': '1/4',
    '30': '1/3',
    '35': '1/2',
    '40': '1',
    '45': '2',
    '50': '3',
    '55': '4',
    '60': '5',
    '65': '6',
    '70': '7',
    '75': '8',
    '80': '9'
}

export const fullMarksNumbers = {
    '0': 1/9,
    '5': 1/8,
    '10': 1/7,
    '15': 1/6,
    '20': 1/5,
    '25': 1/4,
    '30': 1/3,
    '35': 1/2,
    '40': 1,
    '45': 2,
    '50': 3,
    '55': 4,
    '60': 5,
    '65': 6,
    '70': 7,
    '75': 8,
    '80': 9
}

export const revertResult = {
    '1/9': '9',
    '9': '1/9',
    '1/8': '8',
    '8': '1/8',
    '1/7': '7',
    '7': '1/7',
    '1/6': '6',
    '6': '1/6',
    '1/5': '5',
    '5': '1/5',
    '1/4': '4',
    '4': '1/4',
    '3': '1/3',
    '1/3': '3',
    '2': '1/2',
    '1/2': '2',
    '1': '1'
}